<template>

  <SkBasicRows 
    v-if="isLoading"
  />

  <div v-else>
 
    <div class="modal_user_content">

      <div class="image content content_profile">
  
          

        <div class="settings_description">
  

          <div class="row">
            <UiInput
              :label="$t('profile_menu_edit_profile_fb')"
              :text="form.link_facebook.value"
              :error="facebookError"
              :locator="'profile_menu_edit_social_facebook_locator'"
              @change:text="form.link_facebook.value = $event"
              @input="markInteracted('link_facebook')"
              @blur="markDirty('link_facebook')"
              placeholder="https://facebook.com/..."
            />
          </div>

          <div class="row">
            <UiInput
              :label="$t('profile_menu_edit_profile_yt')"
              :text="form.link_youtube.value"
              :error="youtubeError"
              :locator="'profile_menu_edit_social_youtube_locator'"
              @change:text="form.link_youtube.value = $event"
              @input="markInteracted('link_youtube')"
              @blur="markDirty('link_youtube')"
              placeholder="https://youtube.com/..."
            />
          </div>

          <div class="row">
            <UiInput
              :label="$t('profile_menu_edit_profile_ig')"
              :text="form.link_instagram.value"
              :error="instagramError"
              :locator="'profile_menu_edit_social_instagram_locator'"
              @change:text="form.link_instagram.value = $event"
              @input="markInteracted('link_instagram')"
              @blur="markDirty('link_instagram')"
              placeholder="https://instagram.com/..."
            />
          </div>

          <div class="row">
            <UiInput
              :label="$t('profile_menu_edit_profile_tw')"
              :text="form.link_twitter.value"
              :error="twitterError"
              :locator="'profile_menu_edit_social_twitter_locator'"
              @change:text="form.link_twitter.value = $event"
              @input="markInteracted('link_twitter')"
              @blur="markDirty('link_twitter')"
              placeholder="https://twitter.com/..."
            />
          </div>
  

          <div class="row">
            <UiInput
              :label="$t('profile_menu_edit_profile_email')"
              :text="form.link_email.value"
              :error="emailError"
              :locator="'profile_menu_edit_social_email_locator'"
              @change:text="form.link_email.value = $event"
              @input="markInteracted('link_email')"
              @blur="markDirty('link_email')"
              placeholder="Email"
            />
          </div>
  
          <br />

          <div v-if="generalError" class="general-error-block">
            {{ generalError }}
          </div>

          <UiButton
            :name="$t('universal_button_save')"
            :type="'primary'"
            :locator="'universal_button_save_locator'"
            @click="saveSocials"
            :is-loading="isSaving"
            />        

 

        </div>

      </div>

    </div>

    <!-- <UserSettingsModalChangePassword 
      :user-id="userSocialsData.id"
      :active="activeModalChangePassword" 
      :old-password="userSocialsData.password_old"
      @close="closeModalPassword"
      /> -->
  

  </div>

    

</template>

<script setup lang="ts">


import type { User } from '@/types/user'
import { useFormValidation } from '~/composables/useFormValidation'
import { socialsFormConfig } from '~/types/validation/formsConfig'

const { t } = useI18n();
const route = useRoute();

const router = useRouter();
const {$api} = useNuxtApp()

interface Props {
  user: User,
  userId: number,
}

const props = defineProps<Props>();

 

const activeModalChangePassword = ref(false);
const isSaving = ref(false);
const oldNickName = ref('');
const generalError = ref('')

const form = reactive({
  link_facebook: {
    value: '',
    isInteracted: false,
    isDirty: false
  },
  link_youtube: {
    value: '',
    isInteracted: false,
    isDirty: false
  },
  link_instagram: {
    value: '',
    isInteracted: false,
    isDirty: false
  },
  link_twitter: {
    value: '',
    isInteracted: false,
    isDirty: false
  },
  link_email: {
    value: '',
    isInteracted: false,
    isDirty: false
  }
})

const { validateField, markInteracted, markDirty, validateOptionalForm } = useFormValidation(form, socialsFormConfig)

const validation = {
  link_facebook: computed(() => validateField('link_facebook')),
  link_youtube: computed(() => validateField('link_youtube')),
  link_instagram: computed(() => validateField('link_instagram')),
  link_twitter: computed(() => validateField('link_twitter')),
  link_email: computed(() => validateField('link_email'))
}

const backendErrors = reactive({
  link_facebook: '',
  link_youtube: '',
  link_instagram: '',
  link_twitter: '',
  link_email: ''
})

const facebookError = computed(() => backendErrors.link_facebook || validation.link_facebook.value.errorMessage)
const youtubeError = computed(() => backendErrors.link_youtube || validation.link_youtube.value.errorMessage)
const instagramError = computed(() => backendErrors.link_instagram || validation.link_instagram.value.errorMessage)
const twitterError = computed(() => backendErrors.link_twitter || validation.link_twitter.value.errorMessage)
const emailError = computed(() => backendErrors.link_email || validation.link_email.value.errorMessage)

const closeModalPassword = function(){
  activeModalChangePassword.value = false;
}

const validate = () => validateOptionalForm()

const saveSocials = function(){

  if(!validate()){
    return;
  }
  
  const updatedData = {
    ...userSocialsData.value,
    link_facebook: form.link_facebook.value,
    link_youtube: form.link_youtube.value,
    link_instagram: form.link_instagram.value,
    link_twitter: form.link_twitter.value,
    link_email: form.link_email.value
  }
  
  isSaving.value = true;  
  $api.putGrowerProfile(userSocialsData.value.id, updatedData)
  .then((res) => {
    isSaving.value = false;
    useToast().success(t('profile_menu_edit_profile_message_save_profile'));
    useAuth().refresh();
  })
  .catch(function (error) {
    generalError.value = t('universal_generic_error')
    isSaving.value = false;
  });

}

const userSocialsData = ref<{}>({})
const isLoading = ref(true)

const fetchUserData = async () => {
  try {
    const response = await $api.getGrowerSettings(props.userId, 'socials')
    userSocialsData.value = response
    oldNickName.value = response.name
    
    form.link_facebook.value = response.link_facebook || ''
    form.link_youtube.value = response.link_youtube || ''
    form.link_instagram.value = response.link_instagram || ''
    form.link_twitter.value = response.link_twitter || ''
    form.link_email.value = response.link_email || ''
  } catch (error) {
    generalError.value = t('universal_generic_error')
  } finally {
    isLoading.value = false
  }
}

onMounted(fetchUserData)

</script>

<style scoped>

.content_profile {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
}

.modal_user_content .settings_description {
    display: inline-block;
    width: calc(100% - 230px);
    vertical-align: middle;
    margin-right: auto;
}

.modal_user_content .settings_avatar {
    display: inline-block;
    vertical-align: top;
    width: 180px;
    margin-left: 30px;
    position: relative;
}
 
.modal_user_content .ava{
  width: 180px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.modal_user_content .ava .img{
  aspect-ratio: 1/1;
  width: 100%;
  border-radius: 10px;
    border-radius: 100%;
}


.modal_user_content .btn_black {
    background-color: #1B1C1D;
    color: #FFFFFF;
    text-shadow: none;
}

.modal_user_content .save_profile_btn{
    background-color: #21BA45;
    color: #FFFFFF;
    text-shadow: none;
}

.modal_user_content .settings_description .row{
    display: flex;
    width: 100%;
    margin-top: 15px;
}

.modal_user_content .settings_description .label{
    display: inline-block;
    min-width: 280px;
}

.modal_user_content .settings_description .field_input{
    display: inline-block;
    width: 100%;
}

.modal_user_content .settings_description .field_input input{
    width: 100%;
}



@container pb (max-width: 768px) {

  .modal_user_content .ava{
    justify-content: center;
    margin: 0 auto;
  }
  .content_profile{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .modal_user_content .settings_avatar{

      margin-left: auto;
      margin-right: auto;
  }

  .modal_user_content .settings_description{
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    margin-top: 20px;
  }

  .modal_user_content .settings_description .row{
    display: flex;
    flex-direction: column;
  }

}


</style>
